module.exports = __webpack_public_path__ + "static/media/demo.720740cf.webm";